import React, { Component } from "react";
import Spinner from "../../lib/spinner";
import { Col, Grid, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { If } from "react-extras";
import "./shows.scss";
import "redcircle-brand-css/scss/forms.scss";
import LoadingImage from "../../lib/image";
import get from "lodash/get";
import sortBy from "lodash/sortBy";
import ProgressBar from "../../lib/progress_bar";
import StatsWidgetContainerWrapper from "../../lib/stats/stats_widget_container_wrapper";
import { getImportJobDetail } from "../../../lib/import_jobs_helper";
import {
  HAS_SEEN_WELCOME_MODAL,
  HAS_SIGNED_UP_WITH_INVITE,
} from "../../../constants/user_attributes";
import { CATEGORIES, ACTIONS, gtagEvent } from "../../../lib/google_analytics";
import UserRoles from "../../../constants/roles";
import { displayAdvertisingNotification } from "../../../lib/user_attribute";

class ShowListPage extends Component {
  constructor(props) {
    super(props);
    this.getLoadingHTML = this.getLoadingHTML.bind(this);
  }
  componentDidMount() {
    this.props
      .fetchShowsForUser(this.props.user)
      .then(resp => {
        resp.status === 200 &&
          resp.json.length === 1 &&
          resp.json[0].isDemo &&
          this.props.history.push(`/shows/${resp.json[0].uuid}`);
        return resp;
      })
      .then(resp => {
        // TODO: make this a single call
        resp.status === 200 &&
          resp.json.forEach(show => {
            this.props.getShowCampaigns(show.uuid);
          });
      });
    this.getImportJobs();

    if (get(this.props.user, ["userAttributes", HAS_SEEN_WELCOME_MODAL]) !== "true") {
      const isInvitedUser =
        get(this.props.user, ["userAttributes", HAS_SIGNED_UP_WITH_INVITE]) === "true";
      const isSponsoredUser = this.props.currentRole === UserRoles.Sponsor;
      this.props.showWelcomeModal(isInvitedUser, isSponsoredUser);
      this.props.markWelcomeModalSeen();
    }
  }

  getImportJobs = () => {
    this.props.fetchJobsForUser(this.props.user);
  };

  getAlbumArt = show => {
    return (
      <div key={show.uuid}>
        <div className="show-list-image-container" key={show.uuid}>
          <Link to={"/shows/" + show.uuid} className="show-list-image-link-wrapper">
            <div className="show-list-image-wrapper rounded-image">
              <LoadingImage
                imageURL={`${show.imageURL}?d=200x200`}
                className={"loading-image show-list-image"}
                alt="Show Image"
              />
            </div>
            <If
              condition={displayAdvertisingNotification(
                show,
                this.props.user,
                this.props.campaignItems
              )}>
              <div className={"notification"} />
            </If>
            <p className="show-list-title">{show.title}</p>
          </Link>
        </div>
      </div>
    );
  };

  renderList = showArray => {
    return <div className="show-list">{showArray.map(this.getAlbumArt)}</div>;
  };
  renderNoPodcast = () => {
    return (
      <div className="show-list-table show-list-no-episodes-text">
        <If condition={this.props.isLoading}>
          <Spinner disableBackground={true} isLoading={this.props.isLoading} />
        </If>
        <If condition={!this.props.isLoading}>
          <p className="body-large">You have not imported any podcasts yet</p>
          <Link to={"/shows/create"}>
            <button
              className="btn btn-primary"
              onClick={() => gtagEvent(ACTIONS.CLICK, CATEGORIES.NEW_SHOW_BUTTON)}>
              New
            </button>
          </Link>
          <Link to={"/shows/import"}>
            <button
              className="btn btn-secondary"
              onClick={() => gtagEvent(ACTIONS.CLICK, CATEGORIES.IMPORT_SHOW_BUTTON)}>
              Import
            </button>
          </Link>
        </If>
      </div>
    );
  };

  getProgressBarTitle = importJobs => {
    const titles = importJobs
      .map(job => {
        return get(this.props.shows, [job.showUUID, "title"]);
      })
      .filter(a => a);
    return formatTitleString(titles);
  };

  UNSAFE_componentWillReceiveProps() {
    const importJobs = get(this.props, "importJobs", []);
    if (importJobs && importJobs.length) this.startPoll();
  }

  startPoll = () => {
    if (!this.timeout) {
      this.timeout = setInterval(this.getImportJobs, 5000);
    }
  };

  componentWillUnmount() {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
  }

  userTotalProgressBar = () => {
    let importJobs = get(this.props, "importJobs");
    if (!importJobs) return null;
    importJobs = importJobs.filter(job => get(this.props.shows, [job.showUUID, "isVisible"]));

    const initialValue = {
      total: 0,
      current: 0,
      shouldShowProgressBar: false,
      shouldShowContact: false,
    };
    const accumulateJobDetails = (accumulator, currentValue) => {
      const {
        totalJobs,
        numEpisodesImported,
        shouldShowProgressBar,
        isTimedOut,
        isUnfinished,
      } = getImportJobDetail(currentValue, this.props.shows?.[currentValue.showUUID]);

      if (!isUnfinished) return accumulator;
      accumulator.total += totalJobs;
      accumulator.current += numEpisodesImported;
      accumulator.shouldShowProgressBar |= shouldShowProgressBar;
      accumulator.shouldShowContact |= isTimedOut && isUnfinished;
      return accumulator;
    };
    const jobDetails = importJobs.reduce(accumulateJobDetails, initialValue);
    if (!jobDetails.shouldShowProgressBar) return null;

    const pendingJobs = importJobs.filter(
      importJob => getImportJobDetail(importJob).shouldShowProgressBar === true
    );

    return (
      <div className="show-list-progress-bar">
        <ProgressBar
          title={this.getProgressBarTitle(pendingJobs)}
          current={jobDetails.current}
          total={jobDetails.total}
          {...(jobDetails.shouldShowContact && {
            subtitle: (
              <span>
                Import taking too long? contact <Link to={"/support"}>support</Link>
              </span>
            ),
          })}
        />
      </div>
    );
  };

  render() {
    let showArray = this.props.shows ? Object.values(this.props.shows) : [];
    showArray = showArray.filter(item => {
      return item.isVisible;
    });

    showArray = sortBy(showArray, show => {
      return get(show, "title");
    });

    return (
      <div className="show-list-page-container page-wrapper">
        <Grid fluid>
          <Row>
            <Col xs={12} md={12}>
              <If condition={!this.props.isLoading}>{this.userTotalProgressBar()}</If>
              <div className="show-page-content">
                <div className="show-page__title-bar">
                  <h1 className="show-list-header ">
                    {showArray.length > 0 ? `Podcasts (${showArray.length})` : "Podcasts"}
                  </h1>
                  <div className="show-page-spacer" />
                  <div className="show-page-header-buttons">
                    <Link to="/shows/create">
                      <button className="btn btn-primary btn-small">New</button>
                    </Link>
                    <Link to="/shows/import">
                      <button className="btn btn-primary btn-small btn-small--last">Import</button>
                    </Link>
                  </div>
                </div>

                <hr className="redcircle-divider show-page-divider" />
                {Boolean(showArray.length) && !this.props.isLoading
                  ? this.renderList(showArray)
                  : this.renderNoPodcast()}
              </div>
            </Col>
          </Row>
          <StatsWidgetContainerWrapper />
        </Grid>
      </div>
    );
  }

  getLoadingHTML() {
    return (
      <Grid fluid>
        <Row>
          <Col xs={12} md={10} mdOffset={1}>
            <p>&nbsp;</p>
            <p>
              {this.props.isLoading && "Loading shows..."}
              {!this.props.isLoading && "No shows yet, add one!"}
            </p>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const formatTitleString = showTitles => {
  if (!showTitles.length) return null;
  let titles = showTitles.map(title => (
    <span key={title} className="progress-bar-title">
      {title}
    </span>
  ));
  switch (titles.length) {
    case 1:
      return finalizeTitleString(titles);
    case 2:
      titles.splice(1, 0, ", and ");
      return finalizeTitleString(titles);
    case 3:
      titles.splice(-1, 0, ", and ");
      titles.splice(1, 0, ", ");
      return finalizeTitleString(titles);
    default:
      titles.splice(1, 0, ", ");
      titles.splice(3, 0, ", ");
      titles.splice(5, 0, ", ");
      titles = titles.slice(0, 5);
      titles.push(
        `, and ${showTitles.length - 3} other show${showTitles.length > 4 ? "s" : ""}...`
      );
      return finalizeTitleString(titles);
  }
};

const finalizeTitleString = titles => ["Importing ", ...titles];
export default ShowListPage;
